import { CustomSelect } from "components/CustomSelect/CustomSelect.component";
import { styled } from "theme/default/styled";
import { color_a0b9d2 } from "theme/setter/colorsValues/color_a0b9d2";
import { setBorderRadius_4px } from "theme/setter/setBorderRadiusValues/setBorderRadius_4px";

export const SFilterSelectorSelect = styled(CustomSelect)`
  width: 180px;
  color: transparent;
  background-color: transparent;
  appearance: none;
  -moz-appearance: none;

  border: 1px solid ${color_a0b9d2};

  ${setBorderRadius_4px};

  & > option {
    color: initial;
  }
`;
